import React, {useEffect, useState} from "react";
import {SocialAccount, SocialPlatformNames} from "../../../types/socialTypes";
import Grid from "@mui/material/Grid";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import {useTheme} from "../../../contexts/theme";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import Box from "@mui/material/Box";
import {socialFormFields} from "../../../utils/constants";

interface SocialFormProps {
    socialPlatform: SocialPlatformNames
    socialAccount: SocialAccount
    onFieldChange: (field: string, value: string) => void
    onDelete: () => void;
    onCreate: () => void;
    onUpdate: () => void;
    mode: 'readonly' | 'updatable'
    onChangeMode: (mode: 'readonly' | 'updatable') => void;
}

const secretString = '**************************'

const SocialAccountForm: React.FC<SocialFormProps> = ({socialAccount, socialPlatform, onFieldChange, onDelete, onCreate, onUpdate, mode, onChangeMode }) => {

    const theme = useTheme()

    const inputTextStyle = {
        borderBottomColor:theme.palette.orange,
        backgroundColor: 'none',
        color: theme.palette.white,
        borderColor: theme.palette.white,
        borderRadius: theme.border.width.hard,
        width: '100%',
    }

    return (
        <form>
            <Grid container alignItems="center">
                <Grid item md = {12} lg={9.5}  alignItems="center">
                    <Grid container spacing={2}  alignItems="center">
                        {socialFormFields[socialPlatform].map(socialField => (

                            <Grid item xs={12/socialFormFields[socialPlatform].length} alignItems="center">

                                <TextinputField
                                    readOnly={mode === 'readonly'}
                                    value={socialField.secret && mode === 'readonly' ? secretString : (socialAccount[socialField.name as keyof SocialAccount] ? socialAccount[socialField.name as keyof SocialAccount] as string : '' )}
                                    name={socialField.name}
                                    placeholder={socialField.label}
                                    label={socialField.label}
                                    type={'text'}
                                    variant={'outlined'}
                                    onChange={(e) => onFieldChange(socialField.name, e.target.value)}
                                    {...inputTextStyle}
                                />
                            </Grid>

                        ))}
                    </Grid>
                </Grid>
                <Grid item md={12} lg={2.5} alignItems="center">
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} paddingLeft={theme.spacing.md}>
                        {
                            socialAccount.id === '' ?
                                (<TransparentButton onClick={onCreate} text={"Create Account"}></TransparentButton>) : mode === 'readonly' ?
                                (<TransparentButton onClick={()=> {
                                    onChangeMode('updatable')

                                }} text={"Update Account"}></TransparentButton>) :
                                    (<TransparentButton onClick={()=>{
                                        onUpdate()
                                        onChangeMode('readonly')
                                    }} text={"Save"} width={'138.5px'}></TransparentButton>)
                        }
                        <TransparentButton text={"Delete account"} onClick={onDelete}></TransparentButton>
                    </Box>
                </Grid>
            </Grid>
        </form>
    )
}

export default SocialAccountForm